module.exports = __webpack_public_path__ + "static/media/bg-gradient.8a6b5e10.svg";